










import Vue from 'vue'

export default Vue.extend({
  name: 'SmallQualityCellRenderer',

  computed: {
    stars (): number {
      return 5
    }
  }

})
